export function goodsByGradeMapper(grade, opt) {
	if (!grade || !opt) {
		console.error('goodsByGradeMapper::empty params');
		return {};
	}
	let priceKey = `${grade}Price${opt.optionLevel + 0 === 0 ? '' : opt.optionLevel}`;
	let rateKey = `${grade}DiscountRate${opt.optionLevel + 0 === 0 ? '' : opt.optionLevel}`;
	return {
		...opt,
		price: opt[priceKey],
		dscntRate: opt['goodsEventDiscountRate'] ?? opt[rateKey],
	};
}
